/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemExchangeRateUpdateReqVo
 */
export interface SystemExchangeRateUpdateReqVo {
    /**
     * 汇率类型：1-USD汇率，2-电汇(TT)汇率
     * @type {number}
     * @memberof SystemExchangeRateUpdateReqVo
     */
    rateType: number;
    /**
     * 汇率值
     * @type {number}
     * @memberof SystemExchangeRateUpdateReqVo
     */
    rateValue: number;
    /**
     * 适用期间-开始日期
     * @type {string}
     * @memberof SystemExchangeRateUpdateReqVo
     */
    startDate: string;
    /**
     * 适用期间-结束日期
     * @type {string}
     * @memberof SystemExchangeRateUpdateReqVo
     */
    endDate: string;
}

/**
 * Check if a given object implements the SystemExchangeRateUpdateReqVo interface.
 */
export function instanceOfSystemExchangeRateUpdateReqVo(value: object): value is SystemExchangeRateUpdateReqVo {
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    if (!('rateValue' in value) || value['rateValue'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function SystemExchangeRateUpdateReqVoFromJSON(json: any): SystemExchangeRateUpdateReqVo {
    return SystemExchangeRateUpdateReqVoFromJSONTyped(json, false);
}

export function SystemExchangeRateUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemExchangeRateUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'rateType': json['rateType'],
        'rateValue': json['rateValue'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
    };
}

export function SystemExchangeRateUpdateReqVoToJSON(json: any): SystemExchangeRateUpdateReqVo {
    return SystemExchangeRateUpdateReqVoToJSONTyped(json, false);
}

export function SystemExchangeRateUpdateReqVoToJSONTyped(value?: SystemExchangeRateUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rateType': value['rateType'],
        'rateValue': value['rateValue'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

